import { UPDATE_LANGUAGE } from "../actions/i18nActions";

const defaultState = {
    lang: localStorage.getItem('vtgm-lang') ? localStorage.getItem('vtgm-lang') : "EN"
};

function i18nReducer(state = defaultState, action) {
    console.log("LANG", action);
    switch (action.type) {
        case UPDATE_LANGUAGE:
            return {
                ...state,
                lang: action.lang,
            };
        default:
            return state;
    }
}

export default i18nReducer;